export {default as AnimatedModal} from "./Modal";
